import { Tag } from '@blueprintjs/core'
import React, { useMemo } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import bg2 from '../../../assets/images/bg2.png'
import bg1 from '../../../assets/images/bg1.png'
import { showToastByMenuDirection } from '../../helper/functions'

const levels = ['Beginner', 'Novice', 'Nerd', 'Geek', 'Expert', 'Master', 'Learner', 'Voracious Learner', 'True Learner']
const levelCriteria = {
  8: {
    synapses: 45000,
    runCount: 90,
    completeCount: 45
  },
  7: {
    synapses: 30000,
    runCount: 60,
    completeCount: 30
  },
  6: {
    synapses: 20000,
    runCount: 40,
    completeCount: 20
  },
  5: {
    synapses: 15000,
    runCount: 30,
    completeCount: 15
  },
  4: {
    synapses: 10000,
    runCount: 20,
    completeCount: 10
  },
  3: {
    synapses: 5000,
    runCount: 0,
    completeCount: 0
  },
  2: {
    synapses: 1000,
    runCount: 0,
    completeCount: 0
  },
  1: {
    synapses: 100,
    runCount: 0,
    completeCount: 0
  },
  0: {
    synapses: 100,
    runCount: 0,
    completeCount: 0
  }
}

export function getLevel (synapses, runCount, completeCount) {
  let level
  for (let i = levels.length - 1; i >= 0; i--) {
    const criteria = levelCriteria[i]
    if (synapses >= criteria.synapses && runCount >= criteria.runCount && completeCount >= criteria.completeCount) {
      level = levels[i]
      break
    }
  }
  if (!level) {
    level = levels[0]
  }
  return level
}

export function getNextLevel (level) {
  const currentIndex = levels.findIndex((someLevel) => (someLevel === level))
  if (currentIndex === levels.length - 1) {
    return null
  } else {
    return levels[currentIndex + 1]
  }
}

export function howMuchToBeNextLevel (level, synapses, runCount, completeCount) {
  const currentIndex = levels.findIndex((someLevel) => (someLevel === level))
  if (currentIndex === levels.length - 1) {
    return null
  } else {
    const nextCriteria = levelCriteria[currentIndex + 1]
    return {
      synapses: Math.max(0, Math.ceil(nextCriteria.synapses - synapses)),
      runCount: Math.max(0, nextCriteria.runCount - runCount),
      completeCount: Math.max(0, nextCriteria.completeCount - completeCount)
    }
  }
}

export function levelUpToast (level) {
  showToastByMenuDirection({
    message: (<div>Now Your Level Is <LevelTag level={level} />!</div>),
    icon: 'circle-arrow-up'
  })
}

function LevelTag ({ level }) {
  const decoratingCSS = useMemo(() => {
    switch (level) {
      case levels[8]:
        return `background-image: url(${bg1}) !important; background-size: cover !important; color: var(--baseColor) !important;`
      case levels[7]:
        return `background-image: url(${bg2}) !important; background-size: cover !important; color: var(--baseColor) !important;`
      case levels[6]:
        return 'background-color: var(--primary1) !important; color: var(--baseColor) !important;'
      case levels[5]:
        return 'background-color: var(--reverseColor) !important; color: var(--baseColor) !important;'
      case levels[4]:
        return 'background-color: #C23030 !important;'
      case levels[3]:
        return 'background-color: #0A6640 !important;'
      case levels[2]:
        return 'background-color: #0E5A8A !important;'
      case levels[1]:
        return 'background-color: #D9822B !important;'
      default:
        return ``
    }
  }, [level])

  return (
    <Tag large minimal css={css`${decoratingCSS} min-height: auto !important;`}>{level}</Tag>
  )
}

export default LevelTag
